import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

const MediumLabel = styled(Typography)(({ theme }) => ({
    verticalAlign: 'middle',
    display: 'table-cell',
    fontSize: 16,
    width: '100%',
    color: theme.palette.text.secondary,
    paddingLeft: 16,
}));


export default MediumLabel;